// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FooterTcA_TheComp__a8fXt"};